import { Dispatch, SetStateAction } from 'react';
import CustomDialog from '@/components/ui/Dialog/Dialog';
import { NewCoordinatorDtoIn } from '@/models/in/NewCoordinatorDtoIn';

interface CoordinatorsDialogProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  coordinators: NewCoordinatorDtoIn[];
}

const CoordinatorsDialog = ({ open, setOpen, coordinators }: CoordinatorsDialogProps) => {
  return (
    <CustomDialog open={open} setOpen={setOpen} btnText="close">
      <div style={{ direction: 'rtl', width: '100%' }}>
        <h3 className="heading-h4-semibold mb-4 text-(--font-primary)">רכזים</h3>
        <div style={{ overflowX: 'auto' }}>
          <table className="w-full border-collapse body-sm-regular" style={{ borderRadius: 8, overflow: 'hidden' }}>
            <thead>
              <tr className="bg-(--surface-primary) text-white">
                <th className="p-3 text-right body-sm-semibold">מספר זהות</th>
                <th className="p-3 text-right body-sm-semibold">שם פרטי</th>
                <th className="p-3 text-right body-sm-semibold">שם משפחה</th>
                <th className="p-3 text-right body-sm-semibold">אימייל</th>
                <th className="p-3 text-right body-sm-semibold">מספר פלאפון</th>
              </tr>
            </thead>
            <tbody>
              {coordinators.map((coord, index) => (
                <tr key={index} className="border-b border-(--border-main) hover:bg-(--surface-hover)">
                  <td className="p-3 text-(--font-body-1)">{coord.israeliId}</td>
                  <td className="p-3 text-(--font-body-1)">{coord.firstName}</td>
                  <td className="p-3 text-(--font-body-1)">{coord.lastName}</td>
                  <td className="p-3 text-(--font-body-1)">{coord.email}</td>
                  <td className="p-3 text-(--font-body-1)">{coord.phone}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </CustomDialog>
  );
};

export default CoordinatorsDialog;
